import { ApiClient } from "../ApiClient";

/**
 * Create or initialize a CPA test
 * @param {Object} request - Object containing the method (e.g., { method: "POST" })
 * @param {string} url - The dynamic endpoint path
 * @param {Object} dataQuery - The payload for the test initialization
 * @returns {Promise<Response>}
 */
export const createCpaTest = async (request, url, dataQuery) => {
  // We use the internal #request via a public method to support dynamic methods
  // while ensuring CSRF and 401 logic are applied.
  const method = request.method.toUpperCase();

  if (method === "POST") return ApiClient.post(url, dataQuery);
  if (method === "PUT") return ApiClient.put(url, dataQuery);

  // Fallback for any other methods
  return ApiClient.get(url);
};

/**
 * Fetch the current question for an ongoing test
 */
export const fetchCurrentQuestion = async (url) => {
  // Your original code requested a CSRF token for this GET request.
  // ApiClient.get defaults to requiresCsrf = false.
  // If your backend strictly requires CSRF for this GET, we pass it in headers.
  return ApiClient.get(url);
};

/**
 * Submit answer and get the next question
 */
export const processTestAndGetNextQuestion = async (url, queryData) => {
  return ApiClient.put(url, queryData);
};

/**
 * Get a list of CPA test attempts for the user
 */
export const getCpaTestAttempts = async () => {
  return ApiClient.get("/utils/cpa-test");
};
